import { b2bCrmProfile } from './b2b-crm'
import type { SandboxProfile } from './types'

export const INDUSTRY_PROFILES: Record<string, SandboxProfile> = {
  'b2b-crm': b2bCrmProfile,
}

export const DEFAULT_PROFILE_ID = 'b2b-crm' as const

export function getProfile(id: string): SandboxProfile | undefined {
  return INDUSTRY_PROFILES[id]
}

export function getDefaultProfile(): SandboxProfile {
  return b2bCrmProfile
}
